import React from 'react';

const SearchBar = () => (
  <div className="w-full mb-8">
    <input
      type="text"
      placeholder="Search transactions, accounts, categories, bills, stocks..."
      className="w-full px-5 py-3 rounded-xl border border-gray-200 bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      disabled
    />
  </div>
);

export default SearchBar; 